import React from 'react';

import { Organizer } from '../types';
export const OrganizerContext = React.createContext<Partial<Organizer>>({});
